'use client';
import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { ORDER_QUERIES } from '../../infrastructure/order/utils/queries';
import type {
  GetCustomerOrderRequest,
  GetOrderByTrackingRequest,
  GetUserOrdersRequest,
} from '../../infrastructure/order/utils/types';

export const useOrderService = () => {
  const useSuspenseCustomerOrder = (params: GetCustomerOrderRequest) => {
    return useSuspenseQuery(ORDER_QUERIES.getCustomerOrder(params));
  };

  const useSuspenseUserOrders = (params: GetUserOrdersRequest = {}) => {
    return useSuspenseQuery(ORDER_QUERIES.getUserOrders(params));
  };

  const useAssociateOrder = () => {
    return useMutation(ORDER_QUERIES.associateOrder());
  };

  const useEditShippingAddress = () => {
    const queryClient = useQueryClient();
    return useMutation(ORDER_QUERIES.editShippingAddress(queryClient));
  };

  const useEditBillingAddress = () => {
    return useMutation(ORDER_QUERIES.editBillingAddress());
  };

  const useSuspenseOrderByTracking = (params: GetOrderByTrackingRequest) => {
    return useSuspenseQuery(ORDER_QUERIES.getOrderByTracking(params));
  };

  return {
    useSuspenseCustomerOrder,
    useSuspenseUserOrders,
    useAssociateOrder,
    useEditShippingAddress,
    useEditBillingAddress,
    useSuspenseOrderByTracking,
  };
};
